import { configureMergeState } from 'redux-recompose';

// Lives here, not in store.js, so reducer tests share the real strategy without booting the store.
export const mergeState = (state, diff) => state.merge(diff);

export const setupMergeState = () => configureMergeState(mergeState);
